import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'financial-workspace',
  size: 'full',
  children: {
    employee_costs: {
      size: 'full',
      path: 'employee-costs',
      children: {
        import_result: {
          path: 'import-result',
          size: 'full',
        },
      },
    },
    payroll: {
      size: 'full',
      path: 'payroll',
      children: {
        import_result: {
          path: 'import-result',
          size: 'full',
        },
      },
    },
    compensations: {
      size: 'full',
      path: 'compensations',
      children: {
        import_result: {
          path: 'import-result',
          size: 'full',
        },
      },
    },
  },
} as const satisfies Location
